import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      <Typography variant="h4">ברוכים הבאים למוזמנים</Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={() => navigate("/event-types")}>
          סוגי אירועים
        </Button>
      </Stack>
    </Box>
  );
};

export default HomePage;
